import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { includes } from "ramda";
import { isBlank, notBlank } from "../../../util/ext";
import { useCreatorContext } from "../../CreatorContext";

import CircularProgress from "@material-ui/core/CircularProgress";
import Container from "@material-ui/core/Container";
import Avatar from "@material-ui/core/Avatar";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    alignItems: "center",
    padding: 0,
    minWidth: 300,
  },

  clickable: {
    cursor: "pointer",
  },

  deleted: {
    color: `${theme.palette.error.main} !important`,
  },

  disabled: {
    color: theme.palette.primary.disabled,
  },

  thumbnail: {
    width: 45,
    height: 45,
  },

  main: {
    marginLeft: theme.spacing(3),
    width: 200,
    padding: 0,
    flexGrow: 1,
  },

  title: {
    fontSize: "1.6rem",
  },

  titleLink: {
    color: theme.palette.primary.brandPrimary,
  },

  titleText: {
    color: theme.palette.primary.darker,
  },

  subtitle: {
    fontSize: "1.2rem",
  },

  subtitleLink: {
    color: theme.palette.primary.brandPrimary,
  },

  subtitleText: {
    color: theme.palette.primary.dark,
  },

  wrapper: {
    position: "relative",
  },

  loading: {
    position: "absolute",
    top: 4,
  },
}));

const ContentCard = props => {
  const {
    content,
    loading = false,
    disabled = false,
    handleThumbnailClick,
    handleTitleClick,
  } = props;
  const classes = useStyles();
  const creatorContext = useCreatorContext();

  return (
    <Tooltip title={content.title} placement="bottom-start">
      <Container className={classes.root} maxWidth={false}>
        <div className={classes.wrapper}>
          <Avatar
            onClick={handleThumbnailClick}
            variant="rounded"
            alt={content.title}
            src={
              includes(content.id, creatorContext.updatedThumbnails)
                ? `${content.thumbnailUrl}?&tc=${Date.now()}`
                : content.thumbnailUrl
            }
            className={clsx(classes.thumbnail, {
              [classes.clickable]: notBlank(handleThumbnailClick),
            })}
          />
          {loading && (
            <CircularProgress className={classes.loading} color="primary" />
          )}
        </div>

        <div
          onClick={handleTitleClick}
          className={clsx(classes.main, {
            [classes.clickable]: notBlank(handleTitleClick),
          })}
        >
          <Typography
            noWrap
            classes={{
              root: clsx(classes.title, {
                [classes.titleText]: isBlank(handleTitleClick) && !disabled,
                [classes.titleLink]: notBlank(handleTitleClick),
                [classes.disabled]: disabled,
                [classes.deleted]: content.status === "DELETED",
              }),
            }}
          >
            {content.title}
          </Typography>

          <Typography
            noWrap
            classes={{
              root: clsx(classes.subtitle, {
                [classes.subtitleText]: isBlank(handleTitleClick),
                [classes.subtitleLink]: notBlank(handleTitleClick),
                [classes.deleted]: content.status === "DELETED",
              }),
            }}
          >
            {content.subtitle}
          </Typography>
        </div>
      </Container>
    </Tooltip>
  );
};

export default ContentCard;
